import React from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';

import './style.less';

const PaymentOptions = ({ payments, paymentLink }) => {
  let className = 'payments-usps';
  if (payments.length < 4) className = 'payments-3-usps';
  else if (payments.length === 4) className = 'payments-4-usps';
  else if (payments.length > 4) className = 'payments-5-usps';

  return (
    <div className="payment-options">
      <div className={`paymentsUsps ${className} separator`}>
        {payments.map((payment) => {
          return (
            <div className="paymentItem" key={`item-${payment.body}`}>
              <div className="paymentIcon">
                {payment.icon ? (
                  <img
                    src={`data:image/svg+xml;base64,${payment.icon}`}
                    alt="payment-icon"
                  />
                ) : (
                  <div className="usp-checkmark" />
                )}
              </div>
              {payment.headline && (
                <div className="paymentTitle bold">{payment.headline}</div>
              )}
              <div className="paymentText text">{payment.body}</div>
            </div>
          );
        })}
      </div>
      <div className="payment-paragraphs">
        <div className="text">
          {/* this link is different for each country */}
          <a
            href={paymentLink}
            target="_blank"
            rel="noopener noreferrer"
            className="green-link"
          >
            {t`Read more about your payment options here.`}
          </a>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ usp, general }) => {
  return {
    payments: usp.payments,
    paymentLink: general.local_data.paymentLink,
  };
};

export default connect(mapStateToProps)(PaymentOptions);
